import React, { useEffect, useRef } from 'react';
import { graphql } from 'gatsby';
//@ts-ignore
import * as styles from './page-scroll-indicator.module.css';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import ScrollDownLarge from './ScrollDownLarge';
import ScrollDownSmall from './ScrollDownSmall';
import { KontentRadioMultiChoice } from '../../../types/KontentProps';
import { getMultiChoice } from '../Global/DataUtils';

type displayOptions = 'show' | 'hide';

interface Props {
    kontentItemId?: string;
    large_display_show?: KontentRadioMultiChoice<displayOptions>;
    small_display_show?: KontentRadioMultiChoice<displayOptions>;
}

const PageScrollIndicator: React.FC<Props> = ({
    kontentItemId,
    large_display_show,
    small_display_show,
    ...props
}) => {
    const largeDisplayShow = getMultiChoice(large_display_show) === 'show';
    const smallDisplayShow = getMultiChoice(small_display_show) === 'show';

    const breakpoints = useBreakpoint();
    const arrowRef = useRef<HTMLDivElement>(null);

    // Fades the arrow out over the first 10% of page scroll.
    useEffect(() => {
        let frame = 0;
        const update = () => {
            frame = 0;
            const el = arrowRef.current;
            if (!el) return;
            const max =
                document.documentElement.scrollHeight - window.innerHeight;
            const progress = max > 0 ? window.scrollY / max : 0;
            el.style.opacity = String(Math.max(0, 1 - progress * 10));
        };
        const onScroll = () => {
            if (!frame) frame = requestAnimationFrame(update);
        };

        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        return () => {
            if (frame) cancelAnimationFrame(frame);
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
        };
    }, []);

    return (
        <div
            ref={arrowRef}
            className={styles.arrow}
            data-kontent-item-id={kontentItemId}
        >
            {breakpoints.l && largeDisplayShow ? (
                <ScrollDownLarge {...props} />
            ) : null}
            {!breakpoints.l && smallDisplayShow ? (
                <ScrollDownSmall {...props} />
            ) : null}
        </div>
    );
};

export default PageScrollIndicator;

export const fragmentPageScrollIndicator = graphql`
    fragment PageScrollIndicator on kontent_item_component___page_scroll_indicator {
        id
        elements {
            large_display_show {
                value {
                    codename
                }
            }
            small_display_show {
                value {
                    codename
                }
            }
        }
    }
`;
